// src/constants/claims.ts

export const CLAIMS = {
    // ---------- تک‌سطحی ----------
    Dashboard: 'Dashboard',
    Support: 'Support',
    SuggestedTexts: 'SuggestedTexts',
    LetterArchive: 'LetterArchive',
    SubscriptionManagement: 'SubscriptionManagement',
    RequestForm: 'RequestForm',
    TrainingVideos: 'TrainingVideos',
    Reports: 'Reports',
    FAQ: 'FAQ',
    Users: 'Users',

    // ---------- Cartable ----------
    Cartable: {
        CreditLineFacilities: 'Cartable.CreditLineFacilities',
        InternalResourcesFacilities: 'Cartable.InternalResourcesFacilities',
        Guarantee: 'Cartable.Guarantee',
        BrokerageFacilities: 'Cartable.BrokerageFacilities',
        Investment: 'Cartable.Investment',
        AllCartables: 'Cartable.AllCartables',
        WaitingList: 'Cartable.WaitingList',
        Archive: 'Cartable.Archive',
    },

    // ---------- Supervision ----------
    Supervision: {
        CreditLineFacilities: 'Supervision.CreditLineFacilities',
        InternalResourcesFacilities: 'Supervision.InternalResourcesFacilities',
        Guarantee: 'Supervision.Guarantee',
        BrokerageFacilities: 'Supervision.BrokerageFacilities',
        Investment: 'Supervision.Investment',
        All: 'Supervision.All',
    },

    // ---------- Automation ----------
    Automation: {
        View: 'Automation.View',
    },

    // ---------- Transcript ----------
    Transcript: {
        All: 'Transcript.All',
    },

    // ---------- Request (لیست همه درخواست‌ها) ----------
    Request: {
        InProgress: 'Request.InProgress',
        Completed: 'Request.Completed',
        Returned: 'Request.Returned',
    },

    // ---------- Personnel ----------
    Personnel: {
        View: 'Personnel.View',
    },

    // ---------- Survey (پرسش و پاسخ) ----------
    Survey: {
        View: 'Survey.View',
    },

    // ---------- Finance ----------
    Finance: {
        AllTransactions: 'Finance.AllTransactions',
    },

    // ---------- Letter (لیست تمامی نامه‌ها) ----------
    Letter: {
        All: 'Letter.All',
    },

    // ---------- Settings ----------
    Settings: {
        CRM: 'Settings.CRM',
    },
} as const;

export type ClaimsType = typeof CLAIMS;

// ─── Helper: گروه‌بندی claimها برای روت‌ها ───────────────────────────────
export const CLAIM_GROUPS = {
    Cartable: [
        CLAIMS.Cartable.CreditLineFacilities,
        CLAIMS.Cartable.InternalResourcesFacilities,
        CLAIMS.Cartable.Guarantee,
        CLAIMS.Cartable.BrokerageFacilities,
        CLAIMS.Cartable.Investment,
        CLAIMS.Cartable.AllCartables,
        CLAIMS.Cartable.WaitingList,
        CLAIMS.Cartable.Archive,
    ],
    CartableMain: [
        CLAIMS.Cartable.CreditLineFacilities,
        CLAIMS.Cartable.InternalResourcesFacilities,
        CLAIMS.Cartable.Guarantee,
        CLAIMS.Cartable.BrokerageFacilities,
        CLAIMS.Cartable.Investment,
        CLAIMS.Cartable.AllCartables,
    ],
    Supervision: [
        CLAIMS.Supervision.CreditLineFacilities,
        CLAIMS.Supervision.InternalResourcesFacilities,
        CLAIMS.Supervision.Guarantee,
        CLAIMS.Supervision.BrokerageFacilities,
        CLAIMS.Supervision.Investment,
        CLAIMS.Supervision.All,
    ],
    Request: [
        CLAIMS.Request.InProgress,
        CLAIMS.Request.Completed,
        CLAIMS.Request.Returned,
    ],
} as const;